var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2PushButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 27h7v22h-7v15h-4V12h4v15zm25 9V26L28 38l12 12V40h29v-4H40z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Push_button.68ba028b.svg";
export { SvgJ2PushButton as ReactComponent };